import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiInstagram, FiFacebook, FiMail, FiPhone } = FiIcons;

const Footer = () => {
  return (
    <footer className="bg-warm-900 text-white" id="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1752009564982-photo_5999181830990974370_w.jpg" 
                alt="Elvira Vigliano Logo" 
                className="h-12 w-12 rounded-full border-2 border-primary-400"
              />
              <h3 className="text-2xl font-bold text-primary-400">
                Elvira Vigliano
              </h3>
            </div>
            <p className="text-warm-300 mb-4">
              Gestione completa di affitti brevi in tutta Italia. Massimizza i tuoi guadagni con la nostra gestione chiavi in mano.
            </p>
            <div className="flex space-x-4">
              <a 
                href="https://www.instagram.com/elvira_propertymanager/#" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-warm-400 hover:text-primary-400 transition-colors"
                aria-label="Instagram"
              >
                <SafeIcon icon={FiInstagram} className="h-6 w-6" />
              </a>
              <a 
                href="https://www.facebook.com/profile.php?id=61577142384907" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-warm-400 hover:text-primary-400 transition-colors"
                aria-label="Facebook"
              >
                <SafeIcon icon={FiFacebook} className="h-6 w-6" />
              </a>
            </div>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">Link Utili</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-warm-300 hover:text-primary-400 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/servizi" className="text-warm-300 hover:text-primary-400 transition-colors">
                  Servizi
                </Link>
              </li>
              <li>
                <Link to="/chi-siamo" className="text-warm-300 hover:text-primary-400 transition-colors">
                  Chi Siamo
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-warm-300 hover:text-primary-400 transition-colors">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/simulatore" className="text-warm-300 hover:text-primary-400 transition-colors">
                  Simulatore
                </Link>
              </li>
              <li>
                <Link to="/contatti" className="text-warm-300 hover:text-primary-400 transition-colors">
                  Contatti
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">Contatti</h4>
            <div className="space-y-2">
              <div className="flex items-center space-x-2">
                <SafeIcon icon={FiMail} className="h-5 w-5 text-primary-400" />
                <a 
                  href="mailto:elviraviglianopm@gmail.com" 
                  className="text-warm-300 hover:text-primary-400 transition-colors"
                >
                  elviraviglianopm@gmail.com
                </a>
              </div>
              <div className="flex items-center space-x-2">
                <SafeIcon icon={FiPhone} className="h-5 w-5 text-primary-400" />
                <a 
                  href="tel:+393770457022" 
                  className="text-warm-300 hover:text-primary-400 transition-colors"
                >
                  +39 377 045 7022
                </a>
              </div>
            </div>
          </div>
        </div>
        
        <div className="border-t border-warm-800 mt-8 pt-8 text-center">
          <p className="text-warm-400">
            © 2024 Elvira Vigliano - Property Manager. Tutti i diritti riservati.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;